import middlewareConfig from "./middleware-config";
import { MIDDLEWARE_ENUMS } from "./middleware-constants";

const eChallanCmsService = (api) => {

    const getChallanCmsData = () => {
        return api.get("/api/v1/bff-schema/page/page-template/echallan");
    };

    const getCrossSellBannerData = () => {
        return api.get("/api/v1/bff-schema/consumer-api/carousel?categorySlug=42c9d18c-128d-432b-b0c5-12e9d9c770e3_echallan-crosssellbanners");
    };

    const getFactsData = (count) => {
        return api.get(`/api/v1/bff-schema/consumer-api/core/fact/list/${count}/random?randnumber=1`);
    };

    const getChallanBannerData = () => {
        return api.get("/api/v1/bff-schema/page/page-template/echallan-banner");
    };

    const getChallanFaqData = () => {
        return api.get("/api/v1/bff-schema/page/page-template/challanfaq");
    };

    return {
        getChallanCmsData,
        getCrossSellBannerData,
        getFactsData,
        getChallanBannerData,
        getChallanFaqData
    };
};

export const EChallanCmsService = eChallanCmsService(middlewareConfig(MIDDLEWARE_ENUMS.E_CHALLAN_CMS_SERVICE));
